import React from 'react'
import { Input } from '@mobi/component-library/Selection&Input/Inputs'
import { getNameValidationMessage } from '@mobi/account/Areas/SignUp/Utils'

type Props = {
  firstName: string
  middleName: string
  lastName: string
  setFirstName: (value: string) => void
  setMiddleName: (value: string) => void
  setLastName: (value: string) => void
  isDisabled: boolean
}

export const NameInput = ({
  firstName,
  middleName,
  lastName,
  setFirstName,
  setMiddleName,
  setLastName,
  isDisabled,
}: Props) => {
  const [validationMessages, setValidationMessages] = React.useState<Record<string, string>>({})

  const resetFieldValidation = (field: keyof typeof validationMessages) =>
    setValidationMessages(prev => ({
      ...prev,
      [field]: '',
    }))

  return (
    <>
      <Input
        label='First name'
        name='firstName'
        placeholder='Enter first name'
        required
        maxLength={50}
        value={firstName}
        onChange={e => setFirstName(e.target.value)}
        onFocus={() => resetFieldValidation('firstName')}
        onBlur={e => {
          setValidationMessages(prev => ({
            ...prev,
            firstName: getNameValidationMessage(e.target.value),
          }))
        }}
        isInvalid={!!validationMessages.firstName}
        helpText={validationMessages.firstName || 'Must match your ID documents'}
        isDisabled={isDisabled}
      />

      <Input
        label='Middle name (if applicable)'
        name='middleName'
        placeholder='Enter middle name'
        maxLength={50}
        value={middleName}
        onChange={e => setMiddleName(e.target.value)}
        onFocus={() => resetFieldValidation('middleName')}
        onBlur={e => {
          setValidationMessages(prev => ({
            ...prev,
            middleName: getNameValidationMessage(e.target.value, true),
          }))
        }}
        isInvalid={!!validationMessages.middleName}
        helpText={validationMessages.middleName || 'Must match your ID documents'}
        isDisabled={isDisabled}
      />

      <Input
        label='Last name'
        name='lastName'
        placeholder='Enter last name'
        required
        maxLength={50}
        value={lastName}
        onChange={e => setLastName(e.target.value)}
        onFocus={() => resetFieldValidation('lastName')}
        onBlur={e => {
          setValidationMessages(prev => ({
            ...prev,
            lastName: getNameValidationMessage(e.target.value),
          }))
        }}
        isInvalid={!!validationMessages.lastName}
        helpText={validationMessages.lastName || 'Must match your ID documents'}
        isDisabled={isDisabled}
      />
    </>
  )
}
